const baseCustomerFields = {
	egonId: {
		title: "Egon ID",
		type: "text",
		mandatory: true,
		md: 6,
		tab: "Details",
		tooltip: "Identifier used for coverage list matching",
	},
	customerId: {
		title: "Customer ID",
		type: "text",
		md: 6,
		tab: "Details",
	},
	reason: {
		title: "Reason",
		type: "text",
		md: 12,
		tab: "Details",
	},
	notes: {
		title: "Notes",
		type: "text",
		md: 12,
		tab: "Details",
	},
	active: {
		title: "Active",
		type: "enum",
		enum: ["true", "false"],
		md: 6,
		tab: "Details",
	},
};

const basePopFields = {
	popId: {
		title: "POP ID",
		type: "text",
		mandatory: true,
		md: 6,
		tab: "Details",
	},
	reason: {
		title: "Reason",
		type: "text",
		md: 12,
		tab: "Details",
	},
	notes: {
		title: "Notes",
		type: "text",
		md: 12,
		tab: "Details",
	},
	active: {
		title: "Active",
		type: "enum",
		enum: ["true", "false"],
		md: 6,
		tab: "Details",
	},
};

export const COVERAGE_LIST_TYPES = {
	BLACKLIST: "blacklist",
	WHITELIST: "whitelist",
};

export const COVERAGE_TABLES = {
	blacklist_customer: {
		key: "blacklist_customer",
		label: "Blacklist Customer",
		listType: COVERAGE_LIST_TYPES.BLACKLIST,
		apiSegment: "blacklist_customer",
		defaultSchema: { ...baseCustomerFields },
		defaultTabs: ["Details"],
	},
	blacklist_customer_fc_fttc: {
		key: "blacklist_customer_fc_fttc",
		label: "Blacklist Customer FC FTTC",
		listType: COVERAGE_LIST_TYPES.BLACKLIST,
		apiSegment: "blacklist_customer_fc_fttc",
		defaultSchema: { ...baseCustomerFields },
		defaultTabs: ["Details"],
	},
	blacklist_customer_fc_ftth: {
		key: "blacklist_customer_fc_ftth",
		label: "Blacklist Customer FC FTTH",
		listType: COVERAGE_LIST_TYPES.BLACKLIST,
		apiSegment: "blacklist_customer_fc_ftth",
		defaultSchema: { ...baseCustomerFields },
		defaultTabs: ["Details"],
	},
	blacklist_customer_fw_fttc: {
		key: "blacklist_customer_fw_fttc",
		label: "Blacklist Customer FW FTTC",
		listType: COVERAGE_LIST_TYPES.BLACKLIST,
		apiSegment: "blacklist_customer_fw_fttc",
		defaultSchema: { ...baseCustomerFields },
		defaultTabs: ["Details"],
	},
	blacklist_pop: {
		key: "blacklist_pop",
		label: "Blacklist POP",
		listType: COVERAGE_LIST_TYPES.BLACKLIST,
		apiSegment: "blacklist_pop",
		defaultSchema: { ...basePopFields },
		defaultTabs: ["Details"],
	},
	whitelist_customer: {
		key: "whitelist_customer",
		label: "Whitelist Customer",
		listType: COVERAGE_LIST_TYPES.WHITELIST,
		apiSegment: "whitelist_customer",
		defaultSchema: { ...baseCustomerFields },
		defaultTabs: ["Details"],
	},
};

export const COVERAGE_TABLE_KEYS = Object.keys(COVERAGE_TABLES);

export const getCoverageTableConfig = (tableKey) => {
	if (!tableKey) return null;
	const normalized = String(tableKey).trim().toLowerCase();
	return COVERAGE_TABLES[normalized] || null;
};

export const isAddMode = (mode) => String(mode || "").toLowerCase() === "add";

export const buildFormDataFromRecord = (record, tableConfig) => {
	if (!record || !tableConfig) return {};

	const schemaKeys = Object.keys(tableConfig.defaultSchema);
	const formData = {};

	schemaKeys.forEach((key) => {
		if (record[key] != null && record[key] !== "") {
			formData[key] = String(record[key]);
		}
	});

	if (record.active != null) {
		formData.active = String(record.active);
	}

	return formData;
};

export const resolveSchemaFromRecord = (record, tableConfig) => {
	if (record?.json_schema && Object.keys(record.json_schema).length > 0) {
		return record.json_schema;
	}
	return tableConfig?.defaultSchema || {};
};
